module.exports = __webpack_public_path__ + "media/10.fa583b66.mp3";